export enum InvoiceTemplateStatusEnum {
  NotSet = -1,
  Visible = 0,
  Hidden = 1,
}
